<template>
  <div class="sel-cate-flavor-wrapper" v-if="data">
    <CateHeader
      :title="data.itemName"
      :trans-show="transSHow"
      :trans-open="transOpen"
      :posSticky="!firstLevel"
    >
      <Breadcrumb
        v-show="!firstLevel"
        :list="stack"
        attr-name="itemName"
        @nav-change="navClick"
      />
    </CateHeader>
    <div class="scroll-box" :class="{'no-full': !firstLevel}" ref="scrollBox">
      <CateHeadImg
        v-if="firstLevel && isH5"
        :headImg="data.headImg"
        :title="getSlodTitle(data)"
      />
      <div
        v-show="firstLevel"
        class="cate-flavor-header padding-center"
        :class="{ 'no-head-img': !hasHeadImg }"
      >
        <WeakTips
          v-if="+data.cHasWine === 1"
          class="cate-msg"
          :content="data.soldDesc"
        />
        <h1
          class="cate-flavor-title"
          ref="cateTitle"
          v-text="data.itemName"
        ></h1>
        <p class="cate-desc" v-if="data.shortDesc" v-text="data.shortDesc"></p>
        <div class="cate-tips-box" v-if="acttips && acttips.length">
          <CateTips
            :disabled="disabled"
            :tips="acttips"
          />
        </div>
        <div class="cate-tips-box" v-if="acttags && acttags.length">
          <LimitTxt v-for="(tag, tagindex) in acttags" :key="tagindex" :content="tag.content"/>
        </div>
        <div class="cate-tips-box" v-else-if="data.tips && data.tips.length">
          <CateTips
            :disabled="disabled"
            :tips="data.tips"
            :moretext="moreTipsText"
          />
        </div>
      </div>
      <div
        class="cate-flavor-content"
        :class="{ 'cate-flavor-next-content': !firstLevel }"
      >
        <CollapseCom
          :content-list="data.contentList"
          :disabled="disabled"
          :is-leaf="isLeaf"
          :is-selected="isSelected"
          :get-group-tip="getGroupTip"
          :get-check-type="getCheckType"
          :get-item-counter="getItemCounter"
          :get-require-tip="getRequireTip"
          :format-display-name="strategy.formatDisplayName"
          :sum-display-price="strategy.sumDisplayPrice"
          :get-disable-status="getDisableStatus"
          :get-counter-disable-status="getCounterDisableStatus"
          @item-click="itemClick"
          @counter-add="counterAdd"
          @counter-remove="counterRemove"
          @disabled-item-click="disabledItemClick"
        />
        <div class="bottom-add-wrapper" v-if="isH5">
          <p class="err-msg-h5" v-if="actMsg" v-text="actMsg"></p>
          <CateAddStepper
            v-model="comCopies"
            :style="{ margin: '0 auto' }"
            :min="minCopies"
            :max="maxCopies"
            :disabled="disabled"
            @input="changeCopies"
          />
        </div>
      </div>
    </div>
    <div class="cate-flavor-footer">
      <CateAdd
        v-if="firstLevel"
        v-model="comCopies"
        :text="btnName"
        :disabled="addDisabledStatus"
        :nowPrice="nowPrice"
        :originPrice="originPrice"
        :cateCurrency="data.currency"
        @add="addShopCart(data)"
      >
        <CateAddStepper
          v-if="!isH5"
          v-model="comCopies"
          :min="minCopies"
          :max="maxCopies"
          :disabled="disabled"
          :style="{ float: 'left' }"
          @input="changeCopies"
        />
      </CateAdd>
      <CateNextLvFooter
        v-else
        :disabled="disabled"
        :nextReady="isItemReady(data)"
        @cancel="cancel(data)"
        @confirm="nextConfirm(data)"
      />
    </div>
    <!-- 加购时提示？ -->
    <el-alert
      v-if="!isH5 && actMsg"
      class="err-msg"
      type="error"
      :title="actMsg"
      :closable="false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import strategy from './strategy';
import CONSTANTS from './constants';
import { getSlodTitle } from '@/components/DishFood/methods';
import { CATE_SOURCE } from '@/const/dishfood';
import WeakTips from '@/components/DishFood/weakTips.vue'
import CateAdd from '@/components/DishFood/cateAdd.vue';
import CateTips from '@/components/DishFood/cateTips.vue';
import LimitTxt from '@/components/CateResult/limittxt';
import CollapseCom from '@/components/CollapseCom';
import CateHeader from '@/components/DishFood/cateHeader.vue';
import Breadcrumb from '@/components/DishFood/breadcrumb.vue';
import CateNextLvFooter from '@/components/DishFood/cateNextLvFooter.vue';
import CateAddStepper from '@/components/DishFood/cateAddStepper.vue';
import CateHeadImg from '@/components/DishFood/cateHeadImg.vue';


export default {
  name: 'TreeCateCard',
  components: {
    WeakTips,
    CateAdd,
    CateTips,
    LimitTxt,
    CollapseCom,
    CateHeader,
    Breadcrumb,
    CateNextLvFooter,
    CateAddStepper,
    CateHeadImg,
  },
  props: {
    data: Object,
    stack: Array,
    source: String,
    disabled: Boolean,
    hasHeadImg: Boolean,
    copies: {
      type: Number,
      default: 1,
    },
    moreTipsText: String,
    actMsg: String,
    nowPrice: String,
    originPrice: String,
    cateItemNum: Number,
    acttips: Array,
    acttags: Array,
  },
  data() {
    return {
      CONSTANTS,
      strategy,
      transSHow: false,
      transOpen: true,
      firstLevel: true,
      comCopies: 1,
      minCopies: 1,
      maxCopies: Infinity,
      btnName: '',
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    addDisabledStatus() {
      if (this.firstLevel) {
        return this.disabled || (!this.isItemReady(this.data) && this.data.contentList.length)
      } else {
        return false
      }
    }
  },
  watch: {
    copies(val) {
      this.comCopies = val;
    },
    stack(val) {
      this.firstLevel = val.length <= 1;
      this.transOpen = val.length <= 1;
      let dom = this?.$refs?.scrollBox;
      this.firstLevel && (this.transSHow = false)
      dom && (dom.scrollTop = 0)
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    changeCopies(n) {
      this.$emit('change-copies', n);
    },
    scrollToView(getIndexFn = this.getRequireNoSelItem) {
      // 获取必选未选item
      let list = this?.data?.contentList || []
      let index = getIndexFn(list)
      if (index < 0) return
      // 控制 n的 高亮效果
      if (index !== -1 && !list[index]._requiredWarning) {
        this.$set(list[index], '_requiredWarning', true)
        setTimeout(() => {
          list[index]._requiredWarning = false
        }, 1100);
      }
      // 如果有必选 未选中的选项 滚动定位效果
      let aHeader = document.querySelectorAll('.el-collapse-item__header')
      aHeader[index].scrollIntoView({block: 'center', inline: 'nearest', behavior: 'smooth'})
    },
    getRequireNoSelItem(list) {
      let n = Array.prototype.findIndex.call(list, (item, index) => {
        let status = this.getRequireTip(item)
        let requiredPending = !!(status && status !== 'completed')
        let limtOrSelPending = !strategy.matchGroup(item)
        return requiredPending || limtOrSelPending
      })
      return n
    },
    addShopCart(data) {
      // disabled 状态 如果因为必选项没有选择 点击时滚动到必选项位置 并红色提示required
      if (!this.disabled && !this.isItemReady(data)) {
        this.scrollToView();
      }
      if (this.addDisabledStatus) return
      // '加入购物车' 最多15个限制  cateItemNum
      if ((this.comCopies + this.cateItemNum) > 15) {
        this.$utils.warningToast(this.$t('抱歉，您最多可加购15个菜品'))
        return;
      }
      this.ok(data);
    },
    nextConfirm(data) {
      if (!this.disabled && !this.isItemReady(data)) {
        this.scrollToView();
        return
      }
      this.ok(data);
    },
    disabledItemClick(index) {
      this.scrollToView(() => index)
    },
    getSlodTitle: getSlodTitle,
    initData() {
      this.btnName = CATE_SOURCE[this.source]?.btnName;
      this.minCopies = CATE_SOURCE[this.source]?.minCopies;
      this.maxCopies = CATE_SOURCE[this.source]?.maxCopies;
      this.stack.length <= 1 && this.bindScroll();
      this.comCopies = this.copies;
      // hasHeadImg
      // this.transOpen = this.hasHeadImg;
    },
    navClick(item) {
      this.$emit('nav-click', item);
    },
    bindScroll() {
      this?.$refs?.scrollBox?.addEventListener('scroll', this.onScroll);
    },
    unbindScroll() {
      this?.$refs?.scrollBox?.removeEventListener('scroll', this.onScroll);
    },
    onScroll(e) {
      if (!this.transOpen) return;
      let dom = this?.$refs?.scrollBox;
      let domTitle = this?.$refs?.cateTitle;
      // let scrollTop = this.isH5 ? 580 : 20
      this.transSHow = dom?.scrollTop > domTitle?.offsetTop - 20;
    },
    // 逻辑
    itemClick(data) {
      if (this.isLeaf(data)) {
        this.$emit('trigger-temp', data);
      }

      if (!this.isLeaf(data)) {
        if (this.isSelected(data)) {
          this.$emit('trigger', data);
        } else {
          this.$emit('go-down', data);
        }
      }
    },
    cancel(data) {
      this.$emit('cancel', data);
      this.$emit('go-up', data);
    },
    ok(data) {
      this.$emit('ok', data);
      this.$emit('go-up', data);
    },
    getRequireTip(group) {
      return this.isMust(group)
        ? this.isCompleted(group)
          ? 'completed'
          : 'required'
        : '';
    },
    isMust(group) {
      // 1必选；2非必选
      return strategy.isMust(group);
    },
    isCounter(group) {
      return strategy.isCounter(group);
    },
    isRadio(group) {
      return strategy.isRadio(group);
    },
    isCheckbox(group) {
      return strategy.isCheckbox(group);
    },
    getCheckType(group) {
      if (this.isCounter(group)) {
        return CONSTANTS.SELECT_TYPE.COUNTER;
      } else if (this.isRadio(group)) {
        return CONSTANTS.SELECT_TYPE.RADIO;
      } else {
        return CONSTANTS.SELECT_TYPE.CHECKBOX;
      }
    },
    isLeaf(data) {
      return strategy.isLeaf(data);
    },
    isSelected(data) {
      return strategy.isSelected(data);
    },
    getItemCounter(data) {
      return strategy.getItemCounter(data);
    },
    isItemReady(data) {
      return !this.isLeaf(data) && strategy.match(data);
    },
    getDisableStatus(group, node) {
      return strategy.shouldDisableRest(group) && !strategy.isSelected(node);
    },
    getCounterDisableStatus(group) {
      return strategy.shouldDisableRest(group);
    },
    getGroupTip(group) {
      const { maxItemNum } = group;
      let tip = strategy.isSelectType(group)
        ? CONSTANTS.LIMIT_TYPE.SELECT(maxItemNum)
        : CONSTANTS.LIMIT_TYPE.LIMIT(maxItemNum);
      return tip;
    },
    counterAdd(item) {
      this.$emit('counter-add', item);
    },
    counterRemove(item) {
      this.$emit('counter-remove', item);
    },
    isCompleted(group) {
      return strategy.matchGroup(group);
    },
  },
  destroyed() {
    this.unbindScroll();
  },
};
</script>

<style lang="scss">
.sel-cate-flavor-wrapper .err-msg {
  .el-alert__title {
    font-family: 'Aspira Medium';
    font-weight: 500;
    display: inline-block;
  }
}
</style>
<style lang="scss" scoped src="./treecatecard.scss"></style>
